class CartAddOns extends HTMLElement {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    this.revealDiscoveryProduct();
    if (window.Shopify?.designMode) return;
    this.addEventListener('submit', this.onSubmit);
    this.trackImpressions();
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.onSubmit);
  }

  revealDiscoveryProduct() {
    const candidates = Array.from(this.querySelectorAll('.cart-addon-card--discovery'));
    if (!candidates.length) return;

    const storageKey = 'tfb-cart-discovery-v1';
    let chosenHandle;

    try {
      chosenHandle = window.sessionStorage.getItem(storageKey);
    } catch (error) {
      chosenHandle = null;
    }

    let chosen = candidates.find((card) => card.dataset.productHandle === chosenHandle);
    if (!chosen) {
      chosen = candidates[Math.floor(Math.random() * candidates.length)];
      try {
        window.sessionStorage.setItem(storageKey, chosen.dataset.productHandle);
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browsers.
      }
    }

    chosen.hidden = false;
  }

  trackEvent(name, card, variantId) {
    const detail = {
      event: name,
      slot: card?.dataset.addonSlot || '',
      productHandle: card?.dataset.productHandle || '',
      variantId: variantId || ''
    };

    document.dispatchEvent(new CustomEvent(`feltbox:${name}`, { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: `feltbox_${name}`, ...detail });
  }

  trackImpressions() {
    this.querySelectorAll('[data-addon-card]:not([hidden])').forEach((card) => {
      this.trackEvent('cart_addon_impression', card);
    });
  }

  async onSubmit(event) {
    const form = event.target.closest('[data-addon-form]');
    if (!form) return;

    event.preventDefault();
    const card = form.closest('[data-addon-card]');
    const button = form.querySelector('[data-addon-add]');
    const variantControl = form.querySelector('[data-addon-variant]');
    const message = form.querySelector('[data-addon-message]');
    const variantId = variantControl?.value;

    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.textContent = 'Adding...';
    message.textContent = '';

    try {
      const addUrl = new URL(form.action, window.location.origin);
      const addPath = window.routes?.cart_add_url || '/cart/add';
      addUrl.pathname = addPath.endsWith('.js') ? addPath : `${addPath}.js`;

      const response = await fetch(addUrl.toString(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'This item could not be added.');

      this.trackEvent('cart_addon_add', card, variantId);
      button.textContent = 'Added';
      message.textContent = 'Added to your basket.';
      window.setTimeout(() => window.location.reload(), 450);
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Add';
      message.textContent = error.message || 'Please try again.';
    }
  }
}

if (!customElements.get('cart-add-ons')) customElements.define('cart-add-ons', CartAddOns);
